//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate')
        /*
         * dragSort wraps jquery ui's sortable functionality (http://api.jqueryui.com/sortable)
         * which allows users to reordering a list or grid of elements by dragging and dropping them
         *
         * @attr onSwap              (Optional) Function fired when two elements switch positions during a drag
         *                            Note: this function can take the following params: e, ui, dragItem, swapItem
         *                            and this function may need to call $scope.$apply() for the update to register
         * @attr onStart             (Optional) Function fired when the drag action starts
         *                            Note: this function can take the following params: e, ui, dragItem
         * @attr onEnd               (Optional) Function fired when the drag action stops
         *                            Note: this function can take the following params: e, ui
         * @attr disabled            (Optional) Value determining whether dragging is disabled
         * @attr containmentSelector (Optional) Selector for the limits of where you can drago to
         *                            Note: Must be unique
         * @attr trackingCategory    (Optional) String use as a category for tracking events
         */
        .directive('dragSort', ['TrackingService', function(TrackingService) {
          return {
            restrict: 'C',
            scope: {
              onSwap: '&',
              onStart: '&',
              onEnd: '&',
              disabled: '=',
              containmentSelector: '@',
              trackingCategory: '@',
              scroll: '&',
              cancel: '&',
            },
            controller: ['$scope', function($scope) {
              $scope.registeredItems = [];
              this.registerItem = function(item) {
                $scope.registeredItems.push(item);
              };
            }],
            link(scope, element) {
                    // Set options for JQuery sortable (see for details: http://api.jqueryui.com/sortable)
              const options = {
                helper: 'clone',
                placeholderForceSize: true,
                cancel: scope.cancel(), // prevent dragging from elements that match this selector
                scroll: scope.scroll(), // prevent container from auto-scrolling while dragging
                tolerance: 'pointer',
                items: '.drag-sort-item:not(.no-drag)',
                containment: scope.containmentSelector ? angular.element(document).find(scope.containmentSelector) : element,
                        // fired at the start of the drag action
                start(e, ui) {
                  const dragIndex = angular.element(ui.item).attr('drag-index');
                  scope.dragItem = _(scope.registeredItems).find((item) => {
                    return item.dragIndex === dragIndex;
                  });
                  scope.swapIndex = angular.element(ui.item).index();
                  if (scope.onStart) {
                    scope.onStart({ e, ui, dragItem: scope.dragItem });
                  }
                },
                        // fired when dragged item 'swaps' with another item in the list
                change(e, ui) {
                  if (scope.onSwap) {
                    scope.onSwap({ e, ui, dragItem: scope.dragItem, swapItem: getSwapItem(e, ui) });
                  }
                },
                        // fired at the end of the drag action
                stop(e, ui) {
                  if (scope.onEnd) {
                    scope.onEnd({ e, ui });
                  }
                  if (scope.trackingCategory) {
                    TrackingService.recordEvent(scope.trackingCategory, TrackingService.ACTION_DRAG_SORT);
                  }
                },
              };

                    // Determines what item the dragged item was swapped with
              function getSwapItem(e, ui) {
                let swapElem;

                        // Determine which DOM element was swapped based on the movement of the placeholder
                const swapIndex = angular.element(ui.placeholder).index('.drag-sort-item:not(.ui-sortable-helper)');
                if (scope.swapIndex < swapIndex) {
                  swapElem = angular.element(ui.placeholder).prev();
                } else {
                  swapElem = angular.element(ui.placeholder).next();
                }
                scope.swapIndex = swapIndex;

                        // Use drag-index attribute to match the DOM element to a corresponding scope element
                return _(scope.registeredItems).find((item) => {
                  return item.dragIndex === angular.element(swapElem).attr('drag-index');
                });
              }

              scope.$on('dragSort:itemsChanged', ($event, newList) => {
                scope.registeredItems = angular.copy(newList); // copy the list in order to safely modify it
              });

                    // If a disabled value was passed in, watch it to set enable/disable sort
              if (_.property('disabled')(scope)) {
                scope.$watch('disabled', (newVal) => {
                  angular.element(element).sortable(newVal ? 'enable' : 'disable');
                });
              }

                    // Pass options into sortable to set functionality
              angular.element(element).sortable(options);
            },
          };
        }]);
})();
